module.exports = __webpack_public_path__ + "img/security-complete.a6935b9f.svg";